export const getLocalStorageInfoMonitor = () =>{
  let infoMonitorStorage = '';
  var getInfoMonitorConfig = false;
  if(localStorage.getItem("infoMonitorStorage") !== null){
    infoMonitorStorage = localStorage.getItem("infoMonitorStorage");
    try{
      getInfoMonitorConfig = JSON.parse(infoMonitorStorage);
    }catch(e){
    }
  }
  return getInfoMonitorConfig;
}

export const setShowSetupForce = () =>{
  localStorage.setItem('showSetupPageForce', true);
}

export const getShowSetupForce = () =>{
  return localStorage.getItem('showSetupPageForce');
}

export const removeShowSetupForce = () =>{
  localStorage.removeItem('showSetupPageForce');
}

export const removeLocalStorageInfoMonitor= () =>{
  localStorage.removeItem('infoMonitorStorage');
}

export const setLocalStorageInfoMonitor= (ip, token) =>{
  localStorage.setItem('infoMonitorStorage', JSON.stringify({ip,token}));
}



// WEBPACK FOOTER //
// ./src/tools/LocalStorageHandler.js